// semeia-disable-reexport
import type Store from "@ember-data/store";
import Ember from "ember";
import type Medic from "parog-web/models/medic";
import type { SemeiaMedicSession } from "parog-web/services/session";
import PatientListFilterSerializer, {
  PatientListFilterParser,
  filterSeparator,
  keyValueSeparator
} from "parog-web/utils/patient-list-filter-serializer";
import { getItemFromLocalStorage } from "parog-web/utils/use-local-storage";
import { setItemInLocalStorage } from "./use-local-storage";

export function initialPatientListFilter(
  store: Store,
  authenticatedMedic: Medic
): string {
  const storedFilter = getItemFromLocalStorage(_selectedFilterKey());
  if (storedFilter && _isValidFilter(storedFilter, store)) {
    return storedFilter;
  }

  return _defaultFilter(authenticatedMedic);
}

export function savePatientListFilter(filter: string): void {
  setItemInLocalStorage(_selectedFilterKey(), filter);
}

function _defaultFilter(medic: Medic): string {
  const filters = {
    fur: "all",
    medicId: medic.id,
    healthCentreId: "all",
    patientStatus: "enrolled",
    taskType: "all",
    responsibleId: "all",
    tlsConsentStatus: "all"
  };
  return Object.entries(filters)
    .map(([key, value]) => `${key}${keyValueSeparator}${value}`)
    .join(filterSeparator);
}

function _isValidFilter(serializedFilter: string, store: Store): boolean {
  const parser = new PatientListFilterParser({
    serializedFilter,
    store
  });
  return parser.isValid;
}

export function _selectedFilterKey(): string {
  const key = "medics-web.protected.updates.selectedFilter";
  if (Ember.testing) {
    return `test-${key}`;
  }
  return key;
}

export function computeFilter(
  selectedFilter: string | undefined,
  store: Store,
  session: SemeiaMedicSession
): {
  serializedFilter: string;
  filter: PatientListFilterSerializer;
} {
  const serializedFilter =
    selectedFilter || initialPatientListFilter(store, session.medic);
  savePatientListFilter(serializedFilter);
  const filter = new PatientListFilterSerializer({
    serializedFilter,
    store
  });
  return { serializedFilter, filter };
}
